import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../AuthProvider';

const ProtectedAdminRoute = ({ children }) => {
  const { keycloak, authenticated } = useContext(AuthContext);

  if (!authenticated) {
    return <Navigate to="/" replace />;
  }

  // Check if user has admin role
  const roles = keycloak?.tokenParsed?.realm_access?.roles || [];
  const isAdmin = roles.includes("admin");

  if (!isAdmin) {
    return <Navigate to="/settings/account" replace />;
  }

  return children;
};

export default ProtectedAdminRoute;
